import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {Injectable} from '@angular/core';
import {SelectedOption} from './options/option-row/selected-option';
import {Keys, StorageService} from '../../service/storage.service';
import {EligibilityCheckService} from '../../service/eligibility-check.service';

@Injectable()
export class SelectedOptionResolver implements Resolve<SelectedOption> {
    constructor(private eligibilityCheckService: EligibilityCheckService, private storageService: StorageService) {
    }

    async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<SelectedOption> {
        const selectedCreditOptionId = this.storageService.getItem(Keys.SELECTED_CREDIT_OPTION_ID);
        const loanApplicationId = this.storageService.getItem(Keys.LOAN_ID);

        if (selectedCreditOptionId || loanApplicationId) {
            return await this.getSelectedCreditOption(selectedCreditOptionId, loanApplicationId);
        }
    }

    private async getSelectedCreditOption(selectedCreditOptionId, loanApplicationId): Promise<SelectedOption> {
        try {
            return selectedCreditOptionId ?
                await this.eligibilityCheckService.getSelectedCreditOption(selectedCreditOptionId) :
                await this.eligibilityCheckService.getSelectedCreditOptionByLoanApplicationId(loanApplicationId);
        } catch (error) {
            if (error.status === 404) {
                return undefined;
            } else {
                throw error;
            }
        }
    }
}
